const { _zipCode } = require('../services/zipCodeApi');

export const onChangeLanguageOrZipCodeFillCityStateInShippingAddresses = async () => {

    const shippingAddressesZipCode = document.getElementById('shippingPostalCode').value;

    if(shippingAddressesZipCode.length > 4) {
        try {
            const { data } = await _zipCode(shippingAddressesZipCode);
            document.getElementById('shippingAddressLine1').value = data.results[0].formattedAddress;
            document.getElementById('shippingCity').value = data.results[0].city;
            document.getElementById('shippingState').value = data.results[0].state;
            document.getElementById('shippingCountry').value = data.results[0].country;
        } catch (error) {
            console.log(error);
            document.getElementById('shippingAddressLine1').value = '';
            document.getElementById('shippingCity').value = '';
            document.getElementById('shippingState').value = '';
            document.getElementById('shippingCountry').value = '';
        }

    }
}

export const onChangeLanguageOrZipCodeFillCityStateInBillingAddresses = async () => {
    const billingAddressesZipCode = document.getElementById('billingPostalCode').value;
    if(billingAddressesZipCode.length > 4) {
        try {
            const { data } = await _zipCode(billingAddressesZipCode);
            document.getElementById('billingAddressLine1').value = data.results[0].formattedAddress;
            document.getElementById('billingCity').value = data.results[0].city;
            document.getElementById('billingState').value = data.results[0].state;
            document.getElementById('billingCountry').value = data.results[0].country;
        } catch (error) {
            console.log(error);
            document.getElementById('billingAddressLine1').value = '';
            document.getElementById('billingCity').value = '';
            document.getElementById('billingState').value = '';
            document.getElementById('billingCountry').value = '';
        }

    }
}